export * from './application';
export * from './entity';

import { Paging } from "./application";

const pagingDataElement = document.querySelector('[data-js=paging-data]');

if (pagingDataElement) {
    const pagingData = JSON.parse(pagingDataElement.innerHTML);
    Paging.initialize(pagingData);
}
